/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_Use_Picker_ScopeInputs */

const cs_templates_use_picker_scope = /** @type {(inputs: Templates_Use_Picker_ScopeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rozsah úkolů`)
};

const en_templates_use_picker_scope = /** @type {(inputs: Templates_Use_Picker_ScopeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Task scope`)
};

/**
* | output |
* | --- |
* | "Task scope" |
*
* @param {Templates_Use_Picker_ScopeInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const templates_use_picker_scope = /** @type {((inputs?: Templates_Use_Picker_ScopeInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_Use_Picker_ScopeInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_use_picker_scope(inputs)
	return cs_templates_use_picker_scope(inputs)
});